<template>
  <div>
    <div class="wrapper" id="wrapper">
      <img :src="imageSrc" class="background-image" />
      <img :src="imageSrc" class="additional-image" />
      <canvas id="signature-pad" class="signature-pad" :width="width" :height="height"></canvas>
    </div>
    <v-btn class="btn" elevation="6" rounded
      color="primary"
      dark
      large
 @click="saveSignatureToLocalstorage">Submit</v-btn>
  </div>
</template>

<script>
import SignaturePad from 'signature_pad';

export default {
  data() {
    return {
      imageSrc: 'https://fastly.picsum.photos/id/20/3670/2462.jpg?hmac=CmQ0ln-k5ZqkdtLvVO23LjVAEabZQx2wOaT4pyeG10I', // Path to your JPG image
      height: 0, // Adjust as per your image dimensions
      width: 0, // Adjust as per your image dimensions
      signaturePad: null,
    };
  },
  mounted() {
     setTimeout(() => {
        let box = document.getElementById('wrapper')
      this.height = box.clientHeight
      this.width = box.clientWidth

        // Initialize SignaturePad with the canvas
        this.signaturePad = new SignaturePad(document.getElementById('signature-pad'), {
        backgroundColor: 'rgba(255, 255, 255, 0)',
        penColor: 'rgb(0, 0, 0)',
        maxWidth: 1.5
        });
  }, 1000);    
  },
  methods: {
    saveSignatureToLocalstorage() {
      if (this.signaturePad.isEmpty()) {
        alert('Please provide a signature first.');
        return;
      }
      const signatureDataUrl = this.signaturePad.toDataURL(); // Get data URL of signature image
      localStorage.setItem('signatureImage', signatureDataUrl); // Save signature image to local storage
      alert('Signature saved to local storage.');
    },
  },
};
</script>

<style>
.wrapper {
  position: relative;
  width: 90%;
  margin: 0 auto;
  /* max-width: 1600px; */
}

.background-image {
  display: block;
  width: 100%;
  height: auto;
}

.additional-image {
  display: block;

  width: 100%;
  height: auto;
}

.signature-pad {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.btn {
    display: block;
    float: right;
    bottom: 1em;
    right: 4em;
    margin-top: 2em;
}
</style>



